import { useCallback } from 'react';
import { ZendeskHelpCenterForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm2/ZendeskHelpCenterForm';
import { ZendeskTicketsForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm2/ZendeskTicketsForm';
import type { IntegrationFormProps } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/integrationFormProps';

export type ZendeskIntegrationType = 'Help Center' | 'Tickets';

export const ZendeskIntegrationForm2 = ({
  zendeskIntegrationType,
  prevStep = () => {},
  closePopup = () => {},
}: Pick<IntegrationFormProps, 'prevStep' | 'closePopup'> & {
  zendeskIntegrationType?: ZendeskIntegrationType;
}) => {
  const renderForm = useCallback(() => {
    switch (zendeskIntegrationType) {
      case 'Help Center':
        return (
          <ZendeskHelpCenterForm
            zendeskIntegrationType={zendeskIntegrationType}
            prevStep={prevStep}
            closePopup={closePopup}
          />
        );
      case 'Tickets':
        return (
          <ZendeskTicketsForm
            zendeskIntegrationType={zendeskIntegrationType}
            prevStep={prevStep}
            closePopup={closePopup}
          />
        );
    }
  }, [zendeskIntegrationType]);

  return renderForm();
};
